import React, { useEffect } from 'react'

import { CreateWashingMethodForm, CreateWashingMethodPageHeader } from '@/components/pages/WashingMethods/Create'
import { useDetergents } from '@/pages/Detergents/Detergent.hooks'

import { useCreateWashingMethod } from './Create.hooks'

const CreateWashingMethod = () => {
  const { createWashingMethod, loading } = useCreateWashingMethod()

  const { getAllDetergent, detergents } = useDetergents()

  useEffect(() => {
    getAllDetergent()
  }, [getAllDetergent])

  return (
    <>
      <CreateWashingMethodPageHeader />
      <CreateWashingMethodForm {...{ loading, listDetergent: detergents }} onSubmit={createWashingMethod} />
    </>
  )
}

CreateWashingMethod.displayName = 'CreateWashingMethod'
export default CreateWashingMethod
